import { AnyAction } from "@reduxjs/toolkit"
import { History } from "history"

import { globalStore } from "@/App"
import { setCurrentTeam } from "@/store/teams"
import { setDriversPanelTab, setOrdersPanelTab } from "@/store/ui"
import { Team } from "@/types"

import { DriversStatsTab } from "../MapView/partials/Drivers/DriversPanel"
import { OrdersStatsTab } from "../MapView/partials/Orders/OrdersPanel"

const checkIsCurrentTeam = (teamId: Team["id"]) => globalStore.getState().teams.current?.id === teamId
const appDispatch = <T extends AnyAction>(action: T) => globalStore.dispatch(action)

const shouldOpenInNewTab = (event: React.MouseEvent<HTMLElement, MouseEvent>) => event.ctrlKey || event.button === 1

export function handleDriversCountClick(
  tabToSet: DriversStatsTab,
  team: Team,
  event: React.MouseEvent<HTMLElement, MouseEvent>,
  history: History
) {
  if (shouldOpenInNewTab(event)) {
    const url = `${window.location.origin}/?team_id=${team.id}&drivers_tab=${tabToSet}`
    window.open(url)
  } else {
    if (!checkIsCurrentTeam(team.id)) appDispatch(setCurrentTeam(team))
    appDispatch(setDriversPanelTab(tabToSet))
    history.push("/")
  }
}

export function handleUnsettledPaymentsClick(
  team: Team,
  event: React.MouseEvent<HTMLElement, MouseEvent>,
  history: History
) {
  if (shouldOpenInNewTab(event)) {
    const url = `${window.location.origin}/lokalizacje/nierozliczone?team_id=${team.id}`
    window.open(url)
  } else {
    if (!checkIsCurrentTeam(team.id)) appDispatch(setCurrentTeam(team))
    history.push("/lokalizacje/nierozliczone")
  }
}

export function handleOrdersCountClick(
  tabToSet: OrdersStatsTab,
  team: Team,
  event: React.MouseEvent<HTMLElement, MouseEvent>,
  history: History
) {
  if (shouldOpenInNewTab(event)) {
    const url = `${window.location.origin}/?team_id=${team.id}&orders_tab=${tabToSet}`
    window.open(url)
  } else {
    if (!checkIsCurrentTeam(team.id)) appDispatch(setCurrentTeam(team))
    appDispatch(setOrdersPanelTab(tabToSet))
    history.push("/")
  }
}

export function changeTeam(team: Team, history: History) {
  if (!checkIsCurrentTeam(team.id)) appDispatch(setCurrentTeam(team))
  history.push("/centrum-zdarzen")
}
